import React from 'react';
import axios from 'axios';
import { Spin, Tabs, Button, Card, List } from 'antd';
import { LoadingOutlined, DownloadOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import DataUploadForm from '../components/DataUploadForm';
import BasicSystemSetupPanel from '../components/BasicSystemSetupPanel';
import * as serverconfig from '../serverconn';
import { getAllTemplateList } from '../dataUploadTemplates';
import { downloadUploadTemplate } from '../dataUploadUtils';

var CryptoJS = require('crypto-js');

const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;
const { TabPane } = Tabs;

function callback(key) {
  console.log(key);
}

var token = '';
var sacco = '';

class OnboardingSectionView extends React.Component {
  state = {
    datarequested: false,
    companyprofile: {},
  };

  componentDidMount() {
    if (localStorage.getItem('sacco')) {
      sacco = CryptoJS.AES.decrypt(localStorage.getItem('sacco'), 'my-secret-key@12345').toString(CryptoJS.enc.Utf8);
    } else {
      sacco = '';
    }

    token = localStorage.getItem('token') || '';

    axios.defaults.headers = {
      'Content-Type': 'application/json',
      Authorization: `Token ${token}`,
    };

    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`).then((res) => {
      this.setState({
        companyprofile: res.data,
        datarequested: false,
      });
    });
  }

  renderTemplateList() {
    const onboardingDone = this.state.companyprofile.client_onboarding_done === true;
    const templates = getAllTemplateList().filter(
      (item) => !onboardingDone || !item.onboardingOnly
    );

    return (
      <Card title="Data upload templates" style={{ marginBottom: 16 }}>
        <List
          grid={{ gutter: 16, column: 2 }}
          dataSource={templates}
          renderItem={(item) => (
            <List.Item>
              <Card size="small" title={item.label}>
                <p style={{ fontSize: 12, color: '#666' }}>{item.hint}</p>
                <Button
                  icon={<DownloadOutlined />}
                  type="primary"
                  ghost
                  onClick={() => downloadUploadTemplate(item.uploadtype)}
                >
                  Download template
                </Button>
              </Card>
            </List.Item>
          )}
        />
      </Card>
    );
  }

  render() {
    if (this.state.datarequested === true) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Spin indicator={antIcon} />
        </div>
      );
    }

    return (
      <div>
        <BasicSystemSetupPanel />

        <Tabs defaultActiveKey="002" onChange={callback}>
          <TabPane tab="Instructions" key="001">
            <h3>Step 1 — Click the setup button above</h3>
            <p>
              Use <strong>Run Basic System Setup</strong> to create member types, ID types, districts,
              chart of accounts, core ledger accounts, and a default loan type in one click.
            </p>
            <p>Then create at least one user under <strong>User Accounts</strong> so staff can log in.</p>

            <h3>Step 2 — Import your data</h3>
            <p>
              1. Chart of accounts → 2. Districts → 3. Members/Groups → 4. Opening deposits →
              5. Running loans → 6. Expenses/Incomes → 7. Loan repayments
            </p>
            <p>
              Download templates from the <strong>Data Upload</strong> tab. Row 2 is a sample and is auto-skipped.
            </p>
            <p>
              For member-specific JSON imports, use the{' '}
              <Link to="/dataonboarding_json/">JSON import tool</Link>.
            </p>
          </TabPane>

          <TabPane tab="Data Upload" key="002">
            {this.renderTemplateList()}
            <DataUploadForm />
          </TabPane>
        </Tabs>
      </div>
    );
  }
}

export default OnboardingSectionView;
